export const LISTEN_TO_CURRENT_USER_PROFILE ='LISTEN_TO_CURRENT_USER_PROFILE';

export const LISTEN_TO_SELECTED_USER_PROFILE ='LISTEN_TO_SELECTED_USER_PROFILE';
export const   LISTEN_TO_USER_PHOTO ='LISTEN_TO_USER_PHOTO';
